<div style="height: calc(100%); width: 100%;" data-cy="draw-defaults-container">
  <mat-card appearance="outlined" style="width: 100%; height: calc(100%); display: flex; flex-direction: column;" data-cy="draw-defaults-card">
    <span class="configuration-section-title" data-cy="draw-defaults-title">Draw Defaults</span>
    <app-tdo-configuration-action-bar newHidden="true" (saveClick)="onApply($event)" data-cy="draw-defaults-action-bar"></app-tdo-configuration-action-bar>
    <div style="display: flex;" data-cy="draw-defaults-header-spacer"></div>
    <mat-card-subtitle data-cy="draw-defaults-subtitle">Configure default line width, line color, color fills to be used in Draw</mat-card-subtitle>
    
    <table style="width: 400px; border-spacing: 0 8px;" data-cy="draw-defaults-table">
      <!-- Stroke Width and Color Row -->
      <tr data-cy="draw-defaults-stroke-row">
        <td style="width: 200px; height: 50px;" data-cy="draw-defaults-stroke-width-field">
          <tdo-dropdown-v2 *ngIf="annotationsDefaults" widthString="200px" placeholder="Stroke Width" placeholderPosition="above" [datasource]="Widths" displayProperty="value" [value]="getWidth(this.annotationsDefaults.strokeWidth)" (selectionChange)="onStrokeWidthChange($event); dropdownChange($event);" data-cy="draw-defaults-stroke-width-dropdown"></tdo-dropdown-v2>
        </td>
        <td colspan="3"></td>
      </tr>

      <tr data-cy="draw-defaults-stroke-color-row">
        <td style="width: 200px;" data-cy="draw-defaults-stroke-color-field">
          <app-tdo-color-picker style="width: 100%;" placeholder="Stroke Color" [color]="currentStrokeColor" (colorChange)="onStrokeColorChange($event); configurationService.setDirty();" data-cy="draw-defaults-stroke-color-picker"></app-tdo-color-picker>
        </td>
        <td colspan="3"></td>
      </tr>

      <!-- Line Start Cap Row -->
      <tr data-cy="draw-defaults-line-start-row">
        <td style="width: 200px; height: 50px;" data-cy="draw-defaults-line-start-field">
          <tdo-dropdown-v2 *ngIf="annotationsDefaults" widthString="200px" placeholder="Line Start Cap" placeholderPosition="above" [datasource]="enumKeys" displayProperty="name" [value]="getLineStartCap(this.annotationsDefaults.lineStartCap)" (selectionChange)="onLineStartCapChange($event); dropdownChange($event);" data-cy="draw-defaults-line-start-dropdown"></tdo-dropdown-v2>
        </td>
        <td colspan="3"></td>
      </tr>

      <!-- Line End Cap Row -->
      <tr data-cy="draw-defaults-line-end-row">
        <td style="width: 200px; height: 50px;" data-cy="draw-defaults-line-end-field">
          <tdo-dropdown-v2 *ngIf="annotationsDefaults" widthString="200px" placeholder="Line End Cap" placeholderPosition="above" [datasource]="enumKeys" displayProperty="name" [value]="getLineStartCap(this.annotationsDefaults.lineEndCap)" (selectionChange)="onLineEndCapChange($event); dropdownChange($event);" data-cy="draw-defaults-line-end-dropdown"></tdo-dropdown-v2>
        </td>
        <td colspan="3"></td>
      </tr>

      <!-- Fill Color Row -->
      <tr data-cy="draw-defaults-fill-row">
        <td colspan="4">
          <app-tdo-color-picker style="width: 100%;" label="Fill Color" placeholder="Fill Color" [color]="currentFillColor" (colorChange)="onFillColorChange($event); configurationService.setDirty();" data-cy="draw-defaults-fill-color-picker"></app-tdo-color-picker>
        </td>
      </tr>

      <!-- Font Row -->
      <tr data-cy="draw-defaults-font-row">
        <td style="width: 200px; height: 50px;" data-cy="draw-defaults-font-field">
          <tdo-dropdown-v2 *ngIf="annotationsDefaults" widthString="200px" placeholder="Font" placeholderPosition="above" [datasource]="enumFonts" displayProperty="name" [value]="getFont(this.annotationsDefaults.font)" (selectionChange)="onFontChange($event); dropdownChange($event);" data-cy="draw-defaults-font-dropdown"></tdo-dropdown-v2>
        </td>
        <td colspan="3"></td>
      </tr>

      <!-- Font Size Row -->
      <tr data-cy="draw-defaults-font-size-row">
        <td style="width: 200px; height: 50px;" data-cy="draw-defaults-font-size-field">
          <tdo-dropdown-v2 *ngIf="annotationsDefaults" widthString="200px" placeholder="Font Size" placeholderPosition="above" [datasource]="FontSizes" displayProperty="value" [value]="getFontSize(this.annotationsDefaults.fontSize)" (selectionChange)="onFontSizeChange($event); dropdownChange($event);" data-cy="draw-defaults-font-size-dropdown"></tdo-dropdown-v2>
        </td>
        <td colspan="3"></td>
      </tr>

      <!-- Font Style Row -->
      <tr data-cy="draw-defaults-font-style-row">
        <td style="width: 200px; height: 50px;" data-cy="draw-defaults-font-style-field">
          <tdo-dropdown-v2 *ngIf="annotationsDefaults" widthString="200px" placeholder="Font Style" placeholderPosition="above" [datasource]="enumFontStyles" displayProperty="name" [value]="getFontStyle(this.annotationsDefaults.fontStyle)" (selectionChange)="onFontStyleChange($event); dropdownChange($event);" data-cy="draw-defaults-font-style-dropdown"></tdo-dropdown-v2>
        </td>
        <td colspan="3"></td>
      </tr>
    </table>
  </mat-card>
</div>
